module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h2', [_vm._v("Parc Épique")]), _vm._v(" "), _c('p', [_vm._v("Pour participer, créez un compte. Cela prend environ 30 secondes.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "firebaseui-auth-container"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7cc08ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 458
// module chunks = 1